<template>
  <div id="selector">
    <slot name="button" :on="{ click: showDialog }" :selected="selected">
      <v-btn color="white" dark text @click="showDialog()">
        <v-badge
          color="accent"
          :content="selected.length"
          :value="selected.length > 0"
          overlap
          left
        >
          <v-icon v-if="icon">
            {{ icon }}
          </v-icon>
          {{ label }} 
          <span v-if="selected.length > 0">
            ({{selected.length}})
          </span>
        </v-badge>
      </v-btn>
    </slot>

    <v-dialog v-model="dialog" scrollable :fullscreen="fullscreen" width="500">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn color="white" icon @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-text-field
          v-model="search"
          full-width
          name="buscar"
          label="Buscar"
          clearable
          solo
          dense
          prepend-inner-icon="search"
          single-line
          hide-details
        />

        <v-card-text class="pa-0" style="flex: 1 1 100%;">
          <v-list dense>
            <v-list-item-group
              :key="'list-' + keyList"
              v-model="selected"
              multiple
            >
              <template v-for="item in itemsFiltered">



                <v-list-item
                  v-if="item[itemChildren] != undefined"
                  :key="item.listId"
                  class="sticky-top"
                  active-class="primary--text"
                >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                    <v-simple-checkbox
                    @input="toggleSelectChildren(item)"
                    :indeterminate="hasChildrenSelected(item) && !hasAllChildrenSelected(item)"
                    :value="hasAllChildrenSelected(item)"
                    color="primary"
                    ></v-simple-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item[itemText]"
                      />
                    </v-list-item-content>
                  </template>
                </v-list-item>




                <template v-for="childItem in item[itemChildren]">
                  <v-list-item
                    :key="childItem.listId"
                    :value="childItem"
                    active-class="primary--text"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          :true-value="childItem"
                          color="primary"
                          @click="toggle"
                        />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="childItem[itemText]"
                        />
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>

                <!--
normal item
-->

                <v-list-item
                  v-if="item[itemChildren] === undefined"
                  :key="item.listId"
                  :value="item"
                  active-class="primary--text"
                >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        :true-value="item"
                        color="primary"
                        @click="toggle"
                      />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item[itemText]"
                      />
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn color="primary" text @click="toggleSelectAll()">
            Seleccionar todo
          </v-btn>
          <v-spacer />
          <v-btn color="primary" text @click="showAll()">
            {{ allOptionText }}
          </v-btn>
          <v-btn color="primary" @click="saveSelector()">
            Seleccionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Selector",
  props: {
    items         : { required: true },
    fullscreen    : { default: false, type: Boolean },
    value         : { required: true },
    label         : { default: "Label", type: String },
    icon          : {},
    title         : { default: "title", type: String },
    itemText      : { default: "nombre", type: String },
    itemChildren  : { default: "children", type: String },
    allOptionText : { default: "Ver Todos", type: String }
  },
  data: () => ({
    dialog: false,
    search: "",
    keyList: 1,
    selected: []
  }),
  computed: {
    itemsFiltered() {
      var items = this.items.map(i => {
        i.listId = "item-" + i.id;
        if (i[this.itemChildren]) {
          var children = i[this.itemChildren].map(c => {
            c.listId = "item-child-" + i.id + "-" + c.id;
            return c;
          });
          this.$set(i, this.itemChildren, children);
        }
        return i;
      });

      if (this.search) {
        items = items.reduce((accumulator, item) => {
          //return this.search.toLowerCase().split(" ").every(v => item[this.itemText].toLowerCase().includes(v)) ? item : null;
          var children = item[this.itemChildren];
          if (children) {
            childten = children.filter(child => {
              return this.search
                .toLowerCase()
                .split(" ")
                .every(v => child[this.itemText].toLowerCase().includes(v));
            });
            this.$set(i, this.itemChildren, children);
          }
          if (
            this.search
              .toLowerCase()
              .split(" ")
              .every(v => i[this.itemText].toLowerCase().includes(v)) ||
            (children && children.length > 0)
          ) {
            accumulator.push(i);
          }
          return accumulator;
        }, []);
      }

      return items;
      /*
      return items.map(i =>{
        i.listId = "item-"+i.id;
        if(i[this.itemChildren]){
          var children = i[this.itemChildren].map(c => {
            c.listId = "item-child-"+i.id+"-"+c.id;
            return c;
          })
          this.$set(i, this.itemChildren, children);
        }
        return i;
      })
      */
    }
  },
  watch: {
    value() {
      /*
      var self = this;
      this.selected = _.map(this.value , val => _.find(self.items, item => item.id == val.id && item.children == undefined ));
       */
      this.selected = this.value;
    }
  },
  methods: {
    showDialog() {
      this.dialog = true;
      this.keyList++;
    },
    saveSelector() {
      this.dialog = false;
      var selectedObj = this.selected.filter(selItem => {
        return selItem[this.itemChildren] == undefined;
      });
      this.$emit("input", selectedObj);
    },
    showAll() {
      this.selected = [];
      this.saveSelector();
    },
    cancel() {
      this.dialog = false;
      this.$emit("input", []);
    },
    toggleSelectAll(){
      if(this.selected.length > 0){
        this.selected = [];
      }else{
        this.selectAll();
      }
    },
    selectAll(){
      this.itemsFiltered.forEach(item => {
        if(item[this.itemChildren]){
        item[this.itemChildren].forEach(child => {
          this.selected.push(child);
        });
        }else{
          this.selected.push(item);
        }
      });
    },

    toggleSelectChildren(item) {
      if (this.hasChildrenSelected(item)) {
        this.selected = this.selected.filter( s => !item[this.itemChildren].find(c => c.id== s.id));
      } else {
        this.selected = [ ...this.selected, ...item[this.itemChildren] ];
      }
    },

    getChildrenSelected(item){
      return this.selected.filter(s => (s && s.labor_id == item.id));
    },

    hasChildrenSelected(item){
      return this.getChildrenSelected(item).length > 0;
    },

    hasAllChildrenSelected(item){
      return this.getChildrenSelected(item).length == item[this.itemChildren].length;
    }

  }
};
</script>

<style lang="scss" scoped>
.sticky-top {
  position: sticky;
  top: 0;
  background: rgba(255, 255, 141, 1);
  z-index: 2;
}
</style>
